export function avatarUrl(avatar) {
  return avatar ? avatar.thumb_url || avatar.url : null
}
